export default __webpack_public_path__ + "static/media/FuturaMediumC.95c0e147.ttf";